module.exports = {
	"config": {
		"siteTitle": "JSConf Iceland: March 1-2, 2018",
		"siteDescription": "A two day JavaScript conference in Reykjavik, Iceland."
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_cfp.md",
				"ext": "md",
				"name": "_cfp",
				"extname": ".md",
				"basename": "_cfp.md",
				"dirname": "",
				"stem": "_cfp",
				"path": "_cfp.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/_cfp.md",
				"isAbsolute": false
			},
			"requirePath": "_cfp.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_trips.md",
				"ext": "md",
				"name": "_trips",
				"extname": ".md",
				"basename": "_trips.md",
				"dirname": "",
				"stem": "_trips",
				"path": "_trips.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/_trips.md",
				"isAbsolute": false
			},
			"requirePath": "_trips.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "_about.md",
				"ext": "md",
				"name": "_about",
				"extname": ".md",
				"basename": "_about.md",
				"dirname": "about",
				"stem": "_about",
				"path": "about/_about.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/about/_about.md",
				"isAbsolute": false
			},
			"requirePath": "about/_about.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "contact.jsx",
				"ext": "jsx",
				"name": "contact",
				"extname": ".jsx",
				"basename": "contact.jsx",
				"dirname": "about",
				"stem": "contact",
				"path": "about/contact.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/about/contact.jsx",
				"isAbsolute": false
			},
			"requirePath": "about/contact.jsx",
			"path": "/about/contact/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "about",
				"stem": "index",
				"path": "about/index.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/about/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "about/index.jsx",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "accessibility.jsx",
				"ext": "jsx",
				"name": "accessibility",
				"extname": ".jsx",
				"basename": "accessibility.jsx",
				"dirname": "",
				"stem": "accessibility",
				"path": "accessibility.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/accessibility.jsx",
				"isAbsolute": false
			},
			"requirePath": "accessibility.jsx",
			"path": "/accessibility/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "cfp.jsx",
				"ext": "jsx",
				"name": "cfp",
				"extname": ".jsx",
				"basename": "cfp.jsx",
				"dirname": "",
				"stem": "cfp",
				"path": "cfp.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/cfp.jsx",
				"isAbsolute": false
			},
			"requirePath": "cfp.jsx",
			"path": "/cfp/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "code-of-conduct.jsx",
				"ext": "jsx",
				"name": "code-of-conduct",
				"extname": ".jsx",
				"basename": "code-of-conduct.jsx",
				"dirname": "",
				"stem": "code-of-conduct",
				"path": "code-of-conduct.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/code-of-conduct.jsx",
				"isAbsolute": false
			},
			"requirePath": "code-of-conduct.jsx",
			"path": "/code-of-conduct/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "discounts.jsx",
				"ext": "jsx",
				"name": "discounts",
				"extname": ".jsx",
				"basename": "discounts.jsx",
				"dirname": "",
				"stem": "discounts",
				"path": "discounts.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/discounts.jsx",
				"isAbsolute": false
			},
			"requirePath": "discounts.jsx",
			"path": "/discounts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/home/travis/build/jsis/jsconf.is/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "live.jsx",
				"ext": "jsx",
				"name": "live",
				"extname": ".jsx",
				"basename": "live.jsx",
				"dirname": "",
				"stem": "live",
				"path": "live.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/live.jsx",
				"isAbsolute": false
			},
			"requirePath": "live.jsx",
			"path": "/live/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "schedule.jsx",
				"ext": "jsx",
				"name": "schedule",
				"extname": ".jsx",
				"basename": "schedule.jsx",
				"dirname": "",
				"stem": "schedule",
				"path": "schedule.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/schedule.jsx",
				"isAbsolute": false
			},
			"requirePath": "schedule.jsx",
			"path": "/schedule/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "speakers",
				"stem": "_template",
				"path": "speakers/_template.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "speakers/_template.jsx",
			"templatePath": "/speakers/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "abhinav-rastogi.md",
				"ext": "md",
				"name": "abhinav-rastogi",
				"extname": ".md",
				"basename": "abhinav-rastogi.md",
				"dirname": "speakers",
				"stem": "abhinav-rastogi",
				"path": "speakers/abhinav-rastogi.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/abhinav-rastogi.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/abhinav-rastogi.md",
			"path": "/speakers/abhinav-rastogi",
			"data": {
				"title": "Abhinav Rastogi",
				"talk": "Scaling NodeJS beyond the ordinary",
				"path": "/speakers/abhinav-rastogi",
				"type": "speaker",
				"slug": "abhinav-rastogi",
				"twitter": "_abhinavrastogi",
				"github": "abhinavrastogi",
				"companyWebsite": "https://flipkart.com",
				"company": "Flipkart",
				"sponsor": "flipkart",
				"bio": "I lead frontend development at Flipkart.com. Also interested in game dev, music and space stuff!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "anna-henningsen.md",
				"ext": "md",
				"name": "anna-henningsen",
				"extname": ".md",
				"basename": "anna-henningsen.md",
				"dirname": "speakers",
				"stem": "anna-henningsen",
				"path": "speakers/anna-henningsen.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/anna-henningsen.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/anna-henningsen.md",
			"path": "/speakers/anna-henningsen",
			"data": {
				"title": "Anna Henningsen",
				"talk": "Node.js: Where are we now, where are we going?",
				"path": "/speakers/anna-henningsen",
				"type": "speaker",
				"slug": "anna-henningsen",
				"twitter": "addaleax",
				"github": "addaleax",
				"bio": "Over the last 2 years, Anna has been one of the most active contributors to Node.js core. Currently pursuing a Master’s degree in mathematics in Germany, she is fueled by a passion for Node and its community."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "armagan-amcalar.md",
				"ext": "md",
				"name": "armagan-amcalar",
				"extname": ".md",
				"basename": "armagan-amcalar.md",
				"dirname": "speakers",
				"stem": "armagan-amcalar",
				"path": "speakers/armagan-amcalar.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/armagan-amcalar.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/armagan-amcalar.md",
			"path": "/speakers/armagan-amcalar",
			"data": {
				"title": "Armagan Amcalar",
				"talk": "Code, Play & Rock 'n' Roll: A WebAudio Experiment",
				"path": "/speakers/armagan-amcalar",
				"type": "speaker",
				"slug": "armagan-amcalar",
				"twitter": "dashersw",
				"github": "dashersw",
				"website": "https://arm.ag",
				"company": "unu GmbH",
				"bio": "Armagan is a software architect from Berlin and currently works as the Head of Software Engineering at unu GmbH. Following the software craftsmanship philosophy, he teaches young engineering graduates on software and helps them enter the software industry in various NGO contexts and universities. For the past 4 years, he has been focusing on distributed cloud architectures and developed among many others, an open-source framework, cote.js, for building microservices with Node.js."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "arun-michael-dsouza.md",
				"ext": "md",
				"name": "arun-michael-dsouza",
				"extname": ".md",
				"basename": "arun-michael-dsouza.md",
				"dirname": "speakers",
				"stem": "arun-michael-dsouza",
				"path": "speakers/arun-michael-dsouza.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/arun-michael-dsouza.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/arun-michael-dsouza.md",
			"path": "/speakers/arun-michael-dsouza",
			"data": {
				"title": "Arun Michael Dsouza",
				"talk": "Houdini - What lies ahead",
				"path": "/speakers/arun-michael-dsouza",
				"type": "speaker",
				"slug": "arun-michael-dsouza",
				"twitter": "amdsouza92",
				"github": "arunmichaeldsouza",
				"website": "http://arunmichaeldsouza.com",
				"company": "AdPushup Inc.",
				"bio": "Arun is a Full Stack JavaScript Engineer from New Delhi, India currently working with AdPushup Inc. on various Ad-Tech related technologies and products. He wrote his first large scale ERP application in C++, while he was still in high school, since then he has been an avid technologist, specialising in the web domain. Being an Open Source enthusiast, he has released several utilities and libraries for AngularJS, NodeJS, JavaScript/JQuery, SASS/CSS etc."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "bryan-hughes.md",
				"ext": "md",
				"name": "bryan-hughes",
				"extname": ".md",
				"basename": "bryan-hughes.md",
				"dirname": "speakers",
				"stem": "bryan-hughes",
				"path": "speakers/bryan-hughes.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/bryan-hughes.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/bryan-hughes.md",
			"path": "/speakers/bryan-hughes",
			"data": {
				"title": "Bryan Hughes",
				"talk": "“Works for Me”",
				"path": "/speakers/bryan-hughes",
				"type": "speaker",
				"slug": "bryan-hughes",
				"twitter": "nebrius",
				"github": "nebrius",
				"website": "https://nebri.us",
				"companyWebsite": "https://microsoft.com",
				"company": "Microsoft",
				"sponsor": "microsoft",
				"bio": "Bryan Hughes is a technical evangelist at Microsoft and long-time member of the Node.js and NodeBots communities. Bryan is the creator of Raspi IO which provides Raspberry Pi support for the Johnny-Five JavaScript robotics library. Bryan also created Raver Lights, a distributed wireless wearable lighting system designed for festivals. Outside of tech, Bryan is an amateur photographer, occasional writer, a once upon a time pianist, and a wine aficionado."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "carolyn-stransky.md",
				"ext": "md",
				"name": "carolyn-stransky",
				"extname": ".md",
				"basename": "carolyn-stransky.md",
				"dirname": "speakers",
				"stem": "carolyn-stransky",
				"path": "speakers/carolyn-stransky.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/carolyn-stransky.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/carolyn-stransky.md",
			"path": "/speakers/carolyn-stransky",
			"data": {
				"title": "Carolyn Stransky",
				"talk": "Humanizing Your Documentation",
				"path": "/speakers/carolyn-stransky",
				"type": "speaker",
				"slug": "carolyn-stransky",
				"twitter": "carolstran",
				"github": "carolstran",
				"companyWebsite": "https://www.contentful.com/",
				"company": "Contentful",
				"slides": "https://speakerdeck.com/carolstran/humanizing-your-documentation-full-talk",
				"bio": "Carolyn is an American journalist and JavaScript developer based in Berlin, Germany. There, she works as a technical writer for Contentful and teaches front end development in the evenings at ReDI School of Digital Integration. Her interests revolve around accessibility and technology—with a focus on online abuse, human-computer and self-care."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "catherine-meade.md",
				"ext": "md",
				"name": "catherine-meade",
				"extname": ".md",
				"basename": "catherine-meade.md",
				"dirname": "speakers",
				"stem": "catherine-meade",
				"path": "speakers/catherine-meade.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/catherine-meade.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/catherine-meade.md",
			"path": "/speakers/catherine-meade",
			"data": {
				"title": "Catherine Meade",
				"talk": "GitHub Pull Requests for Everyone",
				"path": "/speakers/catherine-meade",
				"type": "speaker",
				"slug": "catherine-meade",
				"twitter": "catheraaine",
				"github": "catheraaine",
				"website": "http://catheraaine.com",
				"companyWebsite": "https://seesparkbox.com",
				"company": "Sparkbox",
				"bio": "Catherine builds responsive websites up and down the stack with Sparkbox, focusing recently on a single enterprise level design system. Catherine has a strong passion for education; she spends her free time volunteering with Girl Develop It, sitting on the local leadership team and teaching code classes. Her other hobbies include reading, video and tabletop games, and making cat jokes. Twitter (and all the other things) as @catheraaine."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "dan-abramov.md",
				"ext": "md",
				"name": "dan-abramov",
				"extname": ".md",
				"basename": "dan-abramov.md",
				"dirname": "speakers",
				"stem": "dan-abramov",
				"path": "speakers/dan-abramov.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/dan-abramov.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/dan-abramov.md",
			"path": "/speakers/dan-abramov",
			"data": {
				"title": "Dan Abramov",
				"talk": "Beyond React 16",
				"path": "/speakers/dan-abramov",
				"type": "speaker",
				"slug": "dan-abramov",
				"twitter": "dan_abramov",
				"github": "gaearon",
				"companyWebsite": "https://www.facebook.com/",
				"company": "Facebook",
				"sponsor": "facebook",
				"bio": "Dan Abramov is a software developer who is trying to empower others by building tools. He co-authored a few popular JavaScript projects, including Redux, and is currently working on the React team at Facebook."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "dan-gebhardt.md",
				"ext": "md",
				"name": "dan-gebhardt",
				"extname": ".md",
				"basename": "dan-gebhardt.md",
				"dirname": "speakers",
				"stem": "dan-gebhardt",
				"path": "speakers/dan-gebhardt.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/dan-gebhardt.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/dan-gebhardt.md",
			"path": "/speakers/dan-gebhardt",
			"data": {
				"title": "Dan Gebhardt",
				"talk": "Give Apps Online Superpowers by Optimizing them for Offline",
				"path": "/speakers/dan-gebhardt",
				"type": "speaker",
				"slug": "dan-gebhardt",
				"twitter": "dgeb",
				"github": "dgeb",
				"companyWebsite": "http://cerebris.com",
				"company": "Cerebris",
				"bio": "Dan has been developing web applications since the dark ages of the web (i.e. the late 90s). He's on the Ember.js and Glimmer.js core teams, an editor of the JSON:API spec, and the creator of Orbit.js. He loves to travel and hike with his family and fluffy dog."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "david-khourshid.md",
				"ext": "md",
				"name": "david-khourshid",
				"extname": ".md",
				"basename": "david-khourshid.md",
				"dirname": "speakers",
				"stem": "david-khourshid",
				"path": "speakers/david-khourshid.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/david-khourshid.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/david-khourshid.md",
			"path": "/speakers/david-khourshid",
			"data": {
				"title": "David Khourshid",
				"talk": "Simplifying Complex UIs with Finite Automata & Statecharts",
				"path": "/speakers/david-khourshid",
				"type": "speaker",
				"slug": "david-khourshid",
				"twitter": "davidkpiano",
				"github": "davidkpiano",
				"website": "https://www.codepen.io/davidkpiano",
				"companyWebsite": "https://www.microsoft.com/",
				"company": "Microsoft",
				"bio": "David Khourshid is a Florida-based web developer for Microsoft, a tech author, and speaker. Also a fervent open-source contributor, he is passionate about JavaScript, CSS, animation, innovative user interfaces, and cutting-edge front-end technologies. When not behind a computer keyboard, he’s behind a piano keyboard or traveling."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "dominik-kundel.md",
				"ext": "md",
				"name": "dominik-kundel",
				"extname": ".md",
				"basename": "dominik-kundel.md",
				"dirname": "speakers",
				"stem": "dominik-kundel",
				"path": "speakers/dominik-kundel.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/dominik-kundel.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/dominik-kundel.md",
			"path": "/speakers/dominik-kundel",
			"data": {
				"title": "Dominik Kundel",
				"talk": "XSS, CSRF, CSP, JWT, WTF? IDK ¯ (ツ)_/¯",
				"path": "/speakers/dominik-kundel",
				"type": "speaker",
				"slug": "dominik-kundel",
				"twitter": "dkundel",
				"github": "dkundel",
				"website": "https://moin.world",
				"company": "Twilio",
				"sponsor": "twilio",
				"bio": "Dominik is a Developer Evangelist for Twilio in Berlin. He has a passion for JavaScript, hackathons, teaching and good whiskey. You will usually find him speaking at meetups and conferences, mentoring at hackathons and CoderDojos or work on open source projects."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "halldor-and-thordur.md",
				"ext": "md",
				"name": "halldor-and-thordur",
				"extname": ".md",
				"basename": "halldor-and-thordur.md",
				"dirname": "speakers",
				"stem": "halldor-and-thordur",
				"path": "speakers/halldor-and-thordur.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/halldor-and-thordur.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/halldor-and-thordur.md",
			"path": "/speakers/halldor-and-thordur",
			"data": {
				"title": "Halldór Eldjárn & Þórður Hans Baldursson",
				"talk": "Paint Splatter: The making of an interactive artwork",
				"path": "/speakers/halldor-and-thordur",
				"type": "speaker",
				"slug": "halldor-and-thordur",
				"bio": "<p>Halldór Eldjárn and Thordur Hans make up the two man digital art studio Stafli. Together they have created a few interactive art installations here in Iceland. Their most notable works are two pieces that utilise Harpa's giant led light façade in a collaborative and interactive way.</p><p>Halldór's main interest lies in the intersection of art and science. He is currently working with composer Ólafur Arnalds on a generative music project.</p><p>Thordur is a developer and digital artist working for Gangverk, a Reykjavík based contracting company. A few indie projects have been published in his own name, most recently a browser extension called Planternative, a tool to help people who want to become vegan.</p>"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "speakers",
				"stem": "index",
				"path": "speakers/index.js",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/index.js",
				"isAbsolute": false
			},
			"requirePath": "speakers/index.js",
			"path": "/speakers/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "jean-yves-perrier.md",
				"ext": "md",
				"name": "jean-yves-perrier",
				"extname": ".md",
				"basename": "jean-yves-perrier.md",
				"dirname": "speakers",
				"stem": "jean-yves-perrier",
				"path": "speakers/jean-yves-perrier.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/jean-yves-perrier.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/jean-yves-perrier.md",
			"path": "/speakers/jean-yves-perrier",
			"data": {
				"title": "Jean-Yves Perrier",
				"talk": "Today: Making a browser fast, the story of Firefox Quantum.",
				"path": "/speakers/jean-yves-perrier",
				"type": "speaker",
				"slug": "jean-yves-perrier",
				"twitter": "Teoli2003",
				"companyWebsite": "https://mozilla.org/",
				"company": "Mozilla",
				"sponsor": "mozilla",
				"bio": "Initially a C++ developer, Jean-Yves got interest in the Web since the early 90s and finally joined Mozilla in 2011 as a technical writer, than the content lead, of MDN Web docs. Today he is a member of the Developer Outreach team at Mozilla."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "john-feminella.md",
				"ext": "md",
				"name": "john-feminella",
				"extname": ".md",
				"basename": "john-feminella.md",
				"dirname": "speakers",
				"stem": "john-feminella",
				"path": "speakers/john-feminella.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/john-feminella.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/john-feminella.md",
			"path": "/speakers/john-feminella",
			"data": {
				"title": "John Feminella",
				"talk": "Building with Blockchains: Better Distributed Applications",
				"path": "/speakers/john-feminella",
				"type": "speaker",
				"slug": "john-feminella",
				"twitter": "jxxf",
				"github": "fj",
				"website": "http://jxf.me/",
				"companyWebsite": "https://pivotal.io/",
				"company": "Pivotal",
				"bio": "John Feminella is an avid technologist, occasional public speaker, and curiosity advocate. He serves as an advisor to Pivotal, where he works on helping enterprises transform the way they write, operate, and deploy software. He's also the cofounder of a tiny analytics monitoring and reporting startup named UpHex. John lives in Charlottesville, VA and likes meta-jokes, milkshakes, and referring to himself in the third person in speaker bios."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "kate-compton.md",
				"ext": "md",
				"name": "kate-compton",
				"extname": ".md",
				"basename": "kate-compton.md",
				"dirname": "speakers",
				"stem": "kate-compton",
				"path": "speakers/kate-compton.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/kate-compton.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/kate-compton.md",
			"path": "/speakers/kate-compton",
			"data": {
				"title": "Kate Compton",
				"talk": "Creating generative art with Javascript",
				"path": "/speakers/kate-compton",
				"type": "speaker",
				"slug": "kate-compton",
				"twitter": "galaxykate",
				"github": "galaxykate",
				"website": "http://www.galaxykate.com",
				"company": "UC Santa Cruz",
				"bio": "Mad scientist, artist, inventor and researcher from the University of California Santa Cruz. Kate has built tools used by tens of thousands of people (including historians, children, and philosophers) to create interactive online bots."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "madlaina-kalunder.md",
				"ext": "md",
				"name": "madlaina-kalunder",
				"extname": ".md",
				"basename": "madlaina-kalunder.md",
				"dirname": "speakers",
				"stem": "madlaina-kalunder",
				"path": "speakers/madlaina-kalunder.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/madlaina-kalunder.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/madlaina-kalunder.md",
			"path": "/speakers/madlaina-kalunder",
			"data": {
				"title": "Madlaina Kalunder",
				"talk": "Building a raytracing engine with JS",
				"path": "/speakers/madlaina-kalunder",
				"type": "speaker",
				"slug": "madlaina-kalunder",
				"twitter": "anialdam",
				"github": "aadjou",
				"website": "https://madlaina.li/",
				"company": "Archilogic",
				"sponsor": "archilogic",
				"bio": "Madlaina is a full stack developer and a 3d processes magician at Archilogic, 3d content accessible for people working on the web. She graduated at the Zurich University of Arts with a bachelor degree in Design, specialisation Game Design, combining the passion for design and story telling with the newest technologies. Madlaina believes in bringing people of different backgrounds together to solve problems in creative ways."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "maja-wichrowska.md",
				"ext": "md",
				"name": "maja-wichrowska",
				"extname": ".md",
				"basename": "maja-wichrowska.md",
				"dirname": "speakers",
				"stem": "maja-wichrowska",
				"path": "speakers/maja-wichrowska.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/maja-wichrowska.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/maja-wichrowska.md",
			"path": "/speakers/maja-wichrowska",
			"data": {
				"title": "Maja Wichrowska",
				"talk": "Do the Right (to Left) Thing: Directional Content in React",
				"path": "/speakers/maja-wichrowska",
				"type": "speaker",
				"slug": "maja-wichrowska",
				"twitter": "majapw",
				"github": "majapw",
				"companyWebsite": "https://www.airbnb.com/",
				"company": "Airbnb",
				"sponsor": "airbnb",
				"bio": "Maja is a frontend software engineer at Airbnb. Her focus is on shared UI systems and writing sustainable code, and she maintains Airbnb's react-dates library and contributes to many other open-source repos as well."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "martin-kleppe.md",
				"ext": "md",
				"name": "martin-kleppe",
				"extname": ".md",
				"basename": "martin-kleppe.md",
				"dirname": "speakers",
				"stem": "martin-kleppe",
				"path": "speakers/martin-kleppe.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/martin-kleppe.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/martin-kleppe.md",
			"path": "/speakers/martin-kleppe",
			"data": {
				"title": "Martin Kleppe",
				"talk": "Daedalus – Though the Maze of Code",
				"path": "/speakers/martin-kleppe",
				"type": "speaker",
				"slug": "martin-kleppe",
				"twitter": "aemkei",
				"github": "aemkei",
				"website": "http://aem1k.com/",
				"company": "Ubilabs",
				"bio": "Mapper. Reducer. Creator of JSFuck, co-founder of Ubilabs, involved in JSUnconf, code golfing at aem1k.com, GDE for the Google Maps API."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "michael-henretty.md",
				"ext": "md",
				"name": "michael-henretty",
				"extname": ".md",
				"basename": "michael-henretty.md",
				"dirname": "speakers",
				"stem": "michael-henretty",
				"path": "speakers/michael-henretty.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/michael-henretty.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/michael-henretty.md",
			"path": "/speakers/michael-henretty",
			"data": {
				"title": "Michael Henretty",
				"talk": "VoiceHTML - Speech Recognition as a Progressive Enhancement",
				"path": "/speakers/michael-henretty",
				"type": "speaker",
				"slug": "michael-henretty",
				"twitter": "mikehenrty",
				"github": "mikehenrty",
				"website": "http://voice.mozilla.org/",
				"company": "Mozilla",
				"sponsor": "mozilla",
				"bio": "I am a front-end engineer at Mozilla working on Common Voice, a project to crowdsource a large database of voices to be used in open-source speech engines."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "nara-kasbergen.md",
				"ext": "md",
				"name": "nara-kasbergen",
				"extname": ".md",
				"basename": "nara-kasbergen.md",
				"dirname": "speakers",
				"stem": "nara-kasbergen",
				"path": "speakers/nara-kasbergen.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/nara-kasbergen.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/nara-kasbergen.md",
			"path": "/speakers/nara-kasbergen",
			"data": {
				"title": "Nara Kasbergen",
				"talk": "Empathy as a Service: Supporting Mental Health in Tech",
				"path": "/speakers/nara-kasbergen",
				"type": "speaker",
				"slug": "nara-kasbergen",
				"twitter": "xiehan",
				"github": "xiehan",
				"website": "http://nara.codes",
				"company": "NPR",
				"bio": "Nara Kasbergen is a senior full-stack developer in NPR (National Public Radio)’s Digital Media group. She hails from The Netherlands and lived in Munich, Houston, Pittsburgh, Tokyo, and New York City prior to settling down in Washington, DC. In her spare time, she satisfies her foodie habits by trying out all of the best restaurants in the city, collects board games, and watches too much Netflix."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "nicole-chung.md",
				"ext": "md",
				"name": "nicole-chung",
				"extname": ".md",
				"basename": "nicole-chung.md",
				"dirname": "speakers",
				"stem": "nicole-chung",
				"path": "speakers/nicole-chung.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/nicole-chung.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/nicole-chung.md",
			"path": "/speakers/nicole-chung",
			"data": {
				"title": "Nicole Chung",
				"talk": "Sharing is Caring: build a peer-to-peer network with WebRTC",
				"path": "/speakers/nicole-chung",
				"type": "speaker",
				"slug": "nicole-chung",
				"twitter": "redconservatory",
				"github": "nicolechung",
				"website": "https://twg.io",
				"companyWebsite": "https://twg.io/",
				"company": "TWG",
				"sponsor": "twg",
				"bio": "As a Software Engineer at Toronto-based product studio TWG, Nicole Chung works with Node, React, and Redux to build fast and efficient user interfaces. She is also an occasional lead instructor at Canada Learning Code, a non-profit dedicated to building technical skills for all Canadians, and has mentored at HackerYou for their part-time JavaScript courses."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "opher-vishnia.md",
				"ext": "md",
				"name": "opher-vishnia",
				"extname": ".md",
				"basename": "opher-vishnia.md",
				"dirname": "speakers",
				"stem": "opher-vishnia",
				"path": "speakers/opher-vishnia.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/opher-vishnia.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/opher-vishnia.md",
			"path": "/speakers/opher-vishnia",
			"data": {
				"title": "Opher Vishnia",
				"talk": "Wait, you can do that with JavaScript…!?",
				"path": "/speakers/opher-vishnia",
				"type": "speaker",
				"slug": "opher-vishnia",
				"twitter": "opherv",
				"github": "opherv",
				"website": "http://opherv.com",
				"company": "Eko",
				"bio": "For the past four years Opher has been working at Eko as lead creative developer, specializing in web technologies. His day-to-day involves working with both creative teams (design, art, film) as well as development teams to push the envelope of interactive video, a new and exciting creative medium. His latest work involved the VR film “Broken Night” and was featured at Cannes film festival and the Tribeca Film Festival in NYC."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "raisa-cuevas.md",
				"ext": "md",
				"name": "raisa-cuevas",
				"extname": ".md",
				"basename": "raisa-cuevas.md",
				"dirname": "speakers",
				"stem": "raisa-cuevas",
				"path": "speakers/raisa-cuevas.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/raisa-cuevas.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/raisa-cuevas.md",
			"path": "/speakers/raisa-cuevas",
			"data": {
				"title": "Raisa Cuevas",
				"talk": "Augmented Reality: Past, Present, Future",
				"path": "/speakers/raisa-cuevas",
				"type": "speaker",
				"slug": "raisa-cuevas",
				"twitter": "raisaveuc",
				"github": "raisaveuc",
				"companyWebsite": "https://www.google.com",
				"company": "Google",
				"bio": "Raisa is a Creative Engineer at Google, building digital experiences to help users understand the brand. Born and raised in San Francisco, educated in Orange County, and employed in the Silicon Valley, she eventually decided it was time to get out of her California bubble and gain some international experience. Now into her third year in London, Raisa continues to grow more passionate about understanding Google's audiences in Europe, Middle East, and Africa, and their unique needs."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "sarah-drasner.md",
				"ext": "md",
				"name": "sarah-drasner",
				"extname": ".md",
				"basename": "sarah-drasner.md",
				"dirname": "speakers",
				"stem": "sarah-drasner",
				"path": "speakers/sarah-drasner.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/sarah-drasner.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/sarah-drasner.md",
			"path": "/speakers/sarah-drasner",
			"data": {
				"title": "Sarah Drasner",
				"talk": "Live and Machine Learn",
				"path": "/speakers/sarah-drasner",
				"type": "speaker",
				"slug": "sarah-drasner",
				"twitter": "sarah_edo",
				"github": "sdras",
				"website": "https://sarahdrasnerdesign.com",
				"companyWebsite": "https://www.microsoft.com",
				"company": "Microsoft",
				"sponsor": "microsoft",
				"bio": "Sarah is an award-winning Speaker, Sr Cloud Developer Advocate at Microsoft, and Staff Writer at CSS-Tricks. Sarah is also the co-founder of Web Animation Workshops, with Val Head. She’s the author of SVG Animations from O’Reilly and has given Frontend Masters workshops on Vue.js and Advanced SVG Animations."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "sarrah-vesselov.md",
				"ext": "md",
				"name": "sarrah-vesselov",
				"extname": ".md",
				"basename": "sarrah-vesselov.md",
				"dirname": "speakers",
				"stem": "sarrah-vesselov",
				"path": "speakers/sarrah-vesselov.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/sarrah-vesselov.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/sarrah-vesselov.md",
			"path": "/speakers/sarrah-vesselov",
			"data": {
				"title": "Sarrah Vesselov",
				"talk": "How to style in React and not lose friends",
				"path": "/speakers/sarrah-vesselov",
				"type": "speaker",
				"slug": "sarrah-vesselov",
				"twitter": "svesselov",
				"gitlab": "SarrahVesselov",
				"website": "http://sarrahvesselov.com/",
				"companyWebsite": "https://gitlab.com",
				"company": "GitLab",
				"sponsor": "gitlab",
				"bio": "Sarrah Vesselov is a UI/UX Developer with over 10 years of experience in web design and development. She currently works for GitLab as UX Lead, setting the overall direction of UX from both a design and application experience view. Prior to that, she was Senior UI Developer at Nitro Solutions and UI / UX Lead at Mad Mobile. She also serves as the Director for the Women Who Code and Girl Develop It Tampa chapters."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "sean-larkin.md",
				"ext": "md",
				"name": "sean-larkin",
				"extname": ".md",
				"basename": "sean-larkin.md",
				"dirname": "speakers",
				"stem": "sean-larkin",
				"path": "speakers/sean-larkin.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/sean-larkin.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/sean-larkin.md",
			"path": "/speakers/sean-larkin",
			"data": {
				"title": "Sean Thomas Larkin",
				"talk": "webpack 4: The State of the Art",
				"path": "/speakers/sean-larkin",
				"type": "speaker",
				"slug": "sean-larkin",
				"twitter": "thelarkinn",
				"github": "thelarkinn",
				"companyWebsite": "https://www.microsoft.com",
				"company": "Microsoft",
				"sponsor": "microsoft",
				"bio": "Sean Larkin is a Program Manager at Microsoft working on Edge DevTools, expert on Web Performance, and maintainer of webpack. Outside of work, he works with Fortune 500 companies helping them change their culture for Web Performance practices, Open Source, and embracing emerging technologies. In his free time he loves spending time with his family, hiking, woodworking, cooking, gardening, Orchid cultivating, playing video games, hacking on IoT, and Streaming his open source work!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "speakers",
				"base": "will-klein.md",
				"ext": "md",
				"name": "will-klein",
				"extname": ".md",
				"basename": "will-klein.md",
				"dirname": "speakers",
				"stem": "will-klein",
				"path": "speakers/will-klein.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/speakers/will-klein.md",
				"isAbsolute": false
			},
			"requirePath": "speakers/will-klein.md",
			"path": "/speakers/will-klein",
			"data": {
				"title": "Will Klein",
				"talk": "End to End Testing: The Game Has Changed",
				"path": "/speakers/will-klein",
				"type": "speaker",
				"slug": "will-klein",
				"twitter": "willslab",
				"github": "willklein",
				"website": "http://willklein.co/",
				"bio": "Will is a frontend engineer and co-organizes the React Denver meetup. He loves sharing what he can with the community, whether its organizing events, giving talks, or mentoring others. He is proud to be a father and husband, and lives on a healthy diet of coffee and ice cream in Longmont, Colorado."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tickets.jsx",
				"ext": "jsx",
				"name": "tickets",
				"extname": ".jsx",
				"basename": "tickets.jsx",
				"dirname": "",
				"stem": "tickets",
				"path": "tickets.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/tickets.jsx",
				"isAbsolute": false
			},
			"requirePath": "tickets.jsx",
			"path": "/tickets/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "trips.jsx",
				"ext": "jsx",
				"name": "trips",
				"extname": ".jsx",
				"basename": "trips.jsx",
				"dirname": "",
				"stem": "trips",
				"path": "trips.jsx",
				"absolute": "/home/travis/build/jsis/jsconf.is/trips.jsx",
				"isAbsolute": false
			},
			"requirePath": "trips.jsx",
			"path": "/trips/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "venue",
				"base": "_venue.md",
				"ext": "md",
				"name": "_venue",
				"extname": ".md",
				"basename": "_venue.md",
				"dirname": "venue",
				"stem": "_venue",
				"path": "venue/_venue.md",
				"absolute": "/home/travis/build/jsis/jsconf.is/venue/_venue.md",
				"isAbsolute": false
			},
			"requirePath": "venue/_venue.md",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "venue",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "venue",
				"stem": "index",
				"path": "venue/index.js",
				"absolute": "/home/travis/build/jsis/jsconf.is/venue/index.js",
				"isAbsolute": false
			},
			"requirePath": "venue/index.js",
			"path": "/venue/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0